"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorStyleWithOpacity = getColorStyleWithOpacity;
exports.shadeColor = shadeColor;
exports.getPrimaryButtonStyle = getPrimaryButtonStyle;
exports.getPrimaryButtonHoverStyle = getPrimaryButtonHoverStyle;
exports.getSecondaryButtonStyle = getSecondaryButtonStyle;
exports.getSecondaryButtonHoverStyle = getSecondaryButtonHoverStyle;

var _color = require("MeetingsBase/utils/color");

function getColorStyleWithOpacity(primaryColor) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.05;
  var rgb = (0, _color.hexToRGB)(primaryColor);
  return "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + opacity + ")";
}

function shadeColor(color, percent) {
  /**
   * Source code from: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
   * @param {string} color - A hex color string (must start with #)
   * @param {int} percent - Percentage by which to lighten the color, can be negative
   * to darken color
   * @returns {string} color - A color, lightened by the given percentage
   */
  var num = parseInt(color.slice(1), 16);
  var red = (num >> 16) + percent;
  if (red > 255) red = 255;else if (red < 0) red = 0;
  var blue = (num >> 8 & 0x00ff) + percent;
  if (blue > 255) blue = 255;else if (blue < 0) blue = 0;
  var green = (num & 0x0000ff) + percent;
  if (green > 255) green = 255;else if (green < 0) green = 0;
  return "#" + (green | blue << 8 | red << 16).toString(16);
}

function getPrimaryButtonStyle(primaryColor) {
  var color = (0, _color.getPrimaryColorOrDefault)(primaryColor);
  return {
    borderColor: color,
    backgroundColor: color
  };
}

function getPrimaryButtonHoverStyle(primaryColor) {
  var color = (0, _color.getPrimaryColorOrDefault)(primaryColor);
  return {
    borderColor: color,
    backgroundColor: color && shadeColor(color, 40)
  };
}

function getSecondaryButtonStyle(primaryColor) {
  var color = (0, _color.getPrimaryColorOrDefault)(primaryColor);
  return {
    borderColor: color,
    color: color
  };
}

function getSecondaryButtonHoverStyle(primaryColor) {
  var color = (0, _color.getPrimaryColorOrDefault)(primaryColor);
  return {
    borderColor: color,
    color: color,
    backgroundColor: color && getColorStyleWithOpacity(color)
  };
}